import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['video', 'chapterContainer'];

  connect() {
    this.matchVideoHeight();
  }

  matchVideoHeight() {
    if (!this.hasChapterContainerTarget || !this.hasVideoTarget) return;

    if (window.screen.width >= 1024) {
      const height = window
        .getComputedStyle(this.videoTarget)
        .getPropertyValue('padding-bottom');
      this.chapterContainerTarget.style.height = height;
    }
  }
}
